import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, of } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { NzUploadFile } from 'ng-zorro-antd/upload';

@Injectable({
  providedIn: 'root'
})
export class UploadSharedDataService {

  private fileList = new BehaviorSubject<any>(null);
  fileList$ = this.fileList.asObservable();

  private imagensList = new BehaviorSubject<any>(null);
  imagensList$ = this.imagensList.asObservable();

  setFileList(fileList: any): void {
    this.fileList.next(fileList);
  }

  setImagensList(imagensList: any): void {
    this.imagensList.next(imagensList);
  }

}
